module.exports = __webpack_public_path__ + "img/zhouxiangjun.25622dd7.jpg";